var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clean") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 53.998,
    y1: 4,
    x2: 35.746,
    y2: 27.143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.333,26A5.667,5.667,0,0,1,38,31.667a10.356,10.356,0,0,1-.579,2.524A28.2,28.2,0,0,0,38.732,60H4C4,41.222,13.556,26,32.333,26Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 38,
    x2: 60,
    y2: 37.996
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 52,
    x2: 60,
    y2: 51.998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 45,
    x2: 60,
    y2: 44.998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 59,
    x2: 60,
    y2: 59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3,26.81A9.3,9.3,0,0,0,35.761,39.067",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.683,60a43.992,43.992,0,0,1,.325-9.444",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.931,50.556A38.625,38.625,0,0,0,21.366,60",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.448,50.556A33.5,33.5,0,0,0,30.049,60",
    "data-cap": "butt"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.77d2ef07463af017d5258c81acb81b07.svg";
export { ForwardRef as ReactComponent };